// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Cancellation24Hours20 from './Cancellation24Hours20.tsx';
import Cancellation24Hours20Circle from './Cancellation24Hours20Circle.tsx';
import Cancellation24Hours24 from './Cancellation24Hours24.tsx';
import Cancellation24Hours24Circle from './Cancellation24Hours24Circle.tsx';
import Cancellation24Hours40 from './Cancellation24Hours40.tsx';
import Cancellation24Hours48 from './Cancellation24Hours48.tsx';

type Cancellation24HoursProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Cancellation24Hours20,
    Cancellation24Hours20Circle,
    Cancellation24Hours24,
    Cancellation24Hours24Circle,
    Cancellation24Hours40,
    Cancellation24Hours48,
};

const Cancellation24Hours: FC<Cancellation24HoursProps> = ({ variation, ...props }) => {
    const variationKey = `Cancellation24Hours${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Cancellation24Hours" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Cancellation24Hours;
